import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { adminAPI } from '../services/api';
import { FuelRestrictionField } from './FuelRestrictionField';

// Bulk « Énergie » on the selected products
export const BulkFuelDialog = ({ open, onClose, selectedIds, onDone }) => {
  const [types, setTypes] = useState([]);
  const [busy, setBusy] = useState(false);
  const apply = async () => {
    setBusy(true);
    try {
      const r = await adminAPI.bulkFuel(selectedIds, types);
      toast.success(r.message);
      onDone?.();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Opération impossible');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="bulk-fuel-dialog">
        <DialogHeader>
          <DialogTitle>Énergie — {selectedIds.length} produit(s)</DialogTitle>
          <DialogDescription>Remplace la restriction d'énergie des produits sélectionnés. Rien de coché = toutes motorisations.</DialogDescription>
        </DialogHeader>
        <FuelRestrictionField value={types} onChange={setTypes} testId="bulk-fuel" />
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose} data-testid="bulk-fuel-cancel">Annuler</Button>
          <Button type="button" onClick={apply} disabled={busy} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="bulk-fuel-apply">
            {busy && <Loader2 size={14} className="mr-1 animate-spin" />} Appliquer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkFuelDialog;
